import { mobileDevice } from '@bingads-webui-campaign-react/mca-core';

export const getCardWrapperStyles = (_, { palette = {} }) => ({
  cardContainer: {
    backgroundColor: palette.white,
    width: 680,
    boxSizing: 'border-box',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    padding: 24,
    marginTop: 24,
    marginBottom: 32,
    [mobileDevice]: {
      width: 'auto',
    },
  },
  cardHeaderContainer: {
    position: 'relative',
  },
  titleContainer: {
    display: 'flex',
    alignSelf: 'flex-start',
    flexGrow: 1,
    '& .helpbutton': {
      paddingBottom: '0px',
      paddingTop: '0px',
      height: '24px',
    },
  },
});
